import { defineComponent, ref, onMounted, onBeforeUnmount, createBlock, openBlock, unref, normalizeClass, withCtx, createElementVNode, createElementBlock, createCommentVNode, toDisplayString, createVNode, renderSlot, createTextVNode } from 'vue';
import { VueFinalModal as Io } from './basler-components.es380.js';
import _sfc_main$1 from './basler-components.es70.js';
import CloseIcon from './basler-components.es381.js';

const _hoisted_1 = { class: "modal__inner" };
const _hoisted_2 = {
  key: 0,
  class: "modal__header"
};
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "visually-hidden" };
const _hoisted_5 = { class: "modal__content" };
const _hoisted_6 = { class: "modal__content-inner" };
const _hoisted_7 = {
  key: 1,
  class: "modal__footer"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ModalModule",
  props: {
    title: { default: "" },
    confirmText: { default: "" },
    abortText: { default: "" },
    closeIconText: { default: "" },
    clickToClose: { type: Boolean, default: true },
    escToClose: { type: Boolean, default: true },
    adaptiveWidth: { type: Boolean, default: false },
    isFullScreen: { type: Boolean, default: false }
  },
  emits: ["confirm", "abort", "after-close"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const addStyles = () => {
      document.body.style.paddingRight = `${scrollBarWidth.value}px`;
      document.body.style.overflow = "hidden";
    };
    const removeStyles = () => {
      return new Promise((resolve) => {
        document.body.style.removeProperty("padding-right");
        document.body.style.removeProperty("overflow");
        resolve();
      });
    };
    const beforeOpen = () => {
      addStyles();
    };
    const afterClose = () => {
      removeStyles().then(() => {
        emit("after-close");
      });
    };
    const scrollBarWidth = ref(0);
    onMounted(() => {
      if (window && document) {
        const scrollBarWidthTemp = window.innerWidth - document.body.clientWidth;
        scrollBarWidth.value = scrollBarWidthTemp > 0 ? scrollBarWidthTemp : 0;
      }
    });
    onBeforeUnmount(() => {
      removeStyles();
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(Io), {
        class: normalizeClass(["modal", { "modal--adaptive-width": _ctx.adaptiveWidth }, { "modal--is-full-screen": _ctx.isFullScreen }]),
        "overlay-class": "modal__overlay",
        "content-class": "modal__wrapper",
        "overlay-transition": "vfm-fade",
        "content-transition": "vfm-fade",
        "click-to-close": _ctx.clickToClose,
        "esc-to-close": _ctx.escToClose,
        onBeforeOpen: beforeOpen,
        onClosed: afterClose
      }, {
        default: withCtx(() => [
          createElementVNode("div", _hoisted_1, [
            _ctx.title !== "" || _ctx.closeIconText !== "" ? (openBlock(), createElementBlock("header", _hoisted_2, [
              createElementVNode("hgroup", {
                class: normalizeClass(["modal__header-inner", { "modal__header-inner--has-button": _ctx.closeIconText }])
              }, [
                _ctx.title !== "" ? (openBlock(), createElementBlock("h3", _hoisted_3, toDisplayString(_ctx.title), 1)) : createCommentVNode("", true)
              ], 2),
              _ctx.closeIconText ? (openBlock(), createElementBlock("button", {
                key: 0,
                type: "button",
                class: "modal__close-button",
                onClick: _cache[0] || (_cache[0] = ($event) => emit("abort"))
              }, [
                createVNode(unref(CloseIcon)),
                createElementVNode("span", _hoisted_4, toDisplayString(_ctx.closeIconText), 1)
              ])) : createCommentVNode("", true)
            ])) : createCommentVNode("", true),
            createElementVNode("div", _hoisted_5, [
              createElementVNode("div", _hoisted_6, [
                renderSlot(_ctx.$slots, "default")
              ])
            ]),
            _ctx.confirmText !== "" || _ctx.abortText !== "" ? (openBlock(), createElementBlock("footer", _hoisted_7, [
              _ctx.confirmText !== "" ? (openBlock(), createBlock(_sfc_main$1, {
                key: 0,
                onClick: _cache[1] || (_cache[1] = ($event) => emit("confirm")),
                "style-type": "primary",
                class: "btn btn-primary"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.confirmText), 1)
                ]),
                _: 1
              })) : createCommentVNode("", true),
              _ctx.abortText !== "" ? (openBlock(), createBlock(_sfc_main$1, {
                key: 1,
                onClick: _cache[2] || (_cache[2] = ($event) => emit("abort")),
                "style-type": "secondary",
                class: "btn btn-link"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(_ctx.abortText), 1)
                ]),
                _: 1
              })) : createCommentVNode("", true)
            ])) : createCommentVNode("", true)
          ])
        ]),
        _: 3
      }, 8, ["class", "click-to-close", "esc-to-close"]);
    };
  }
});

export { _sfc_main as default };
